module.exports = __webpack_public_path__ + "static/media/pixar-logo@2x.897a7a2f.png";